/** @format */

import React from 'react'
import styled from 'styled-components'
import { Drawer, Message, Tip } from '@king-design/react'
import LaunchForm from '../components/LaunchForm'
import { useAsyncFn } from 'react-use'
import { launchScene } from 'src/api/ApiEventOpsScene'

interface TestDrawerProps {
  className?: string
  visible: boolean
  onClose: () => void
  name: string
  testID: number
  formSchema: string
}

const TestDrawer: React.FC<TestDrawerProps> = ({
  className,
  visible,
  onClose,
  name,
  testID,
  formSchema
}) => {
  const [, fetchLaunchScene] = useAsyncFn(
    async formValues => {
      const result = await launchScene({
        Sign: testID,
        Inputs: formValues,
        PrePublish: true
      })
      if (result?.SceneRecordID) {
        Message.success('发起成功')
        window.open(`/#!/monitor/eventops/record/detail/${result?.SceneRecordID}`, '_blank')
        onClose()
      }
    },
    [testID]
  )

  return (
    <Drawer
      value={visible}
      width={800}
      title={`测试【${name}】`}
      mode="destroy"
      container={() => document.getElementById('scene_detail')}
      onChangeValue={show => {
        if (!show) {
          onClose()
        }
      }}
      slotFooterWrapper={<></>}
    >
      <div className={className}>
        <Tip type="warning" showIcon>
          提交测试后，系统将按照您设定的操作进行执行，请严格确认是否会对线上业务产生影响，谨慎调试。
        </Tip>
        <div className="test_form">
          <LaunchForm
            submitText="提交"
            formSchema={formSchema}
            onCallback={values => {
              fetchLaunchScene(values)
            }}
          />
        </div>
      </div>
    </Drawer>
  )
}

export default styled(TestDrawer)`
  .test_form {
    margin-top: 16px;
  }
`
